import {AdvancedFilter} from "@/poster-gallery/classes/advanced-filters/advanced-filter";

export class DesignStyleFilter extends AdvancedFilter {
    static advancedFiltersArrayKey = 'design_style';
}